import http from "./http";
import mobileHttp from './http-mobile';
import type { Estudiante, EstudianteAsistencia, EstudianteAnotacionST, FormEstudianteData } from "models/estudiante_model";

export type EstudianteFormData = FormEstudianteData;

export const getEstudiantes = async (cursoFilter?: string, turnoFilter?: string, nombreFilter?: string) => {
  try {
  const filters = []
    if (cursoFilter) {
      filters.push(`curso=${cursoFilter}`)
    }
    if (turnoFilter) {
      filters.push(`turno=${turnoFilter}`)
    }
    if (nombreFilter) {
      filters.push(`nombre=${nombreFilter}`)
    }
    return await http.get<Estudiante[]>(`/estudiante/${filters.length ? ('?' + filters.join('&')) : ''}`);
  } catch (error) {
    console.error('[get_estudiantes] error :: ', error);
    return [];
  }
};

export const getEstudiantesConInscripciones = async (cursoFilter?: string, turnoFilter?: string, nombreFilter?: string, gestionFilter?: string) => {
  try {
  const filters = []
    if (cursoFilter) {
      filters.push(`curso=${cursoFilter}`)
    }
    if (turnoFilter) {
      filters.push(`turno=${turnoFilter}`)
    }
    if (nombreFilter) {
      filters.push(`nombre=${nombreFilter}`)
    }
    if (gestionFilter) {
      filters.push(`gestion=${gestionFilter}`)
    }
    return await http.get<Estudiante[]>(`/inscripcion/${filters.length ? ('?' + filters.join('&')) : ''}`);
  } catch (error) {
    console.error('[get_estudiantes_con_inscripciones] error :: ', error);
    return [];
  }
};

export const getEstudianteById = async (id: string) => {
  try {
    return await http.get<Estudiante>(`/estudiante/${id}`);
  } catch (error) {
    console.error('[get_by_id] error :: ', error);
    return null;
  }
}

function getFormData(data: EstudianteFormData, file?: File | File[] | FileList): FormData {
  if (data.hijo) delete data.hijo.imagen;
  const dataArray = new FormData();
  const record = data as unknown as Record<string, unknown>;
  for (const key in record) {
    const value = record[key];
    if (key === 'hijo' || key === 'padre' || key === 'padre2') {
      const subObject = value as Record<string, unknown> | undefined;
      for (const subkey in subObject) {
        dataArray.append(`${key}_${subkey}`, String(subObject[subkey]));
      }
    } else {
      dataArray.append(key, String(value));
    }
  }
  const fileValue = Array.isArray(file) || file instanceof FileList ? file[0] : file;
  if (fileValue) {
    dataArray.append("file", fileValue);
  }

  return dataArray;
}

export const createEstudiante = async (data: EstudianteFormData, file?: File | File[] | FileList) => {
  try {
    if (file) {
      return await http.post<Estudiante, FormData>('/estudiante', getFormData(data, file), {
        "Content-Type": "multipart/form-data"
      });
    }
    return await http.post<Estudiante, EstudianteFormData>('/estudiante', data);
  } catch (error) {
    console.error("[create] Error :: ", error);
    return null;
  }
};

export const editEstudiante = async (data: EstudianteFormData, id: string, file?: File | File[] | FileList) => {
  try {
    if (file) {
      return await http.put<Estudiante, FormData>(`/estudiante/${id}`, getFormData(data, file), {
        "Content-Type": "multipart/form-data"
      });
    }
    return await http.put<Estudiante, EstudianteFormData>(`/estudiante/${id}`, data);
  } catch (error) {
    console.error("[put] Error :: ", error);
    return null;
  }
};

export const updateEstudiante = async (data: EstudianteFormData, id: string) => {
  try {
    return await http.put<Estudiante, EstudianteFormData>(`/estudiante/update/${id}`, data);
  } catch (error) {
    console.error("[put] Error :: ", error);
    return null;
  }
};

export const deleteEstudiante = async (estudianteId: string, cursoId: string) => {
  try {
    return await http.delete(`/estudiante/${estudianteId}/curso/${cursoId}`);
  } catch (error) {
    console.error("[delete] Error :: ", error);
    return null;
  }
};

export const changeCursoEstudiante = async (estudianteId: string, cursoId: string, nuevoCurso: string) => {
  try {
    return await http.put<Estudiante, { nuevoCurso: string }>(`/estudiante/${estudianteId}/curso/${cursoId}/cambiarCurso`, { nuevoCurso });
  } catch (error) {
    console.error("[put] Error :: ", error);
    return null;
  }
};

export const getEstudiantesParaAsistencia = async (cursoId: string, claseId: string): Promise<EstudianteAsistencia[]> => {
  try {
    return await http.get<EstudianteAsistencia[]>(`/curso/${cursoId}/estudiante?clase=${claseId}`);
  } catch (error) {
    console.error("[get] Error :: ", error);
    return [];
  }
};

export const guardarAsistencia = async (data: Record<string, unknown>) => {
  try {
    return await http.post(`/asistencia`, data);
  } catch (error) {
    console.error("[put] Error :: ", error);
    return null;
  }
};

export const getEstudiantesParaAnotacionesSinTarea = async (cursoId: string, claseId: string): Promise<EstudianteAnotacionST[]> => {
  try {
    return await mobileHttp.get<EstudianteAnotacionST[]>(`/curso/${cursoId}/clase/${claseId}/anotacion/Sin%20Tarea`);
  } catch (error) {
    console.error("[get] Error :: ", error);
    return [];
  }
};

export const guardarAnotacionesSinTarea = async (cursoId: string, claseId: string, data: Record<string, unknown>) => {
  try {
    const categoria = 'Sin Tarea';
    return await mobileHttp.post(`/curso/${cursoId}/clase/${claseId}/anotacion/${categoria}`, data);
  } catch (error) {
    console.error("[post] Error :: ", error);
    return null;
  }
};
